import { PlusIcon, ShareNetworkIcon, VectorIcon } from "@codat/orchard-ui";
import { PowerIcon } from "icons/PowerIcon";
import React from "react";

import { paths } from "components/App/paths";

export type GettingStartedName = "gettingStarted" | "addCompany" | "apiAccess";

interface CtaProps {
  text: string;
  href?: string;
  to?: string;
  opensInNewTab: boolean;
  buttonName: string;
}

interface GettingStartedCopy {
  title: string;
  description: string;
  icon: React.ReactNode;
  primaryCta: CtaProps;
  secondaryCta?: CtaProps;
}

export const getGettingStartedCopy = (
  name: GettingStartedName,
  hasAPIKeyViewPermission: boolean
): GettingStartedCopy => {
  switch (name) {
    case "gettingStarted":
      return {
        title: "Getting started",
        description:
          "Check out our first steps guide, explore our API reference to learn about our APIs, and start building today.",
        icon: <PowerIcon />,
        primaryCta: {
          text: "Get started",
          href: "https://docs.codat.io/get-started/first-steps",
          opensInNewTab: true,
          buttonName: "Getting Started - Get Started",
        },
        secondaryCta: {
          text: "API ref",
          href: "https://docs.codat.io/using-the-api/overview",
          opensInNewTab: true,
          buttonName: "Getting Started Card - API ref",
        },
      };
    case "addCompany":
      return {
        title: "Add a company",
        description:
          "Learn the basics and add your first company in the Portal.",
        icon: <PlusIcon />,
        primaryCta: {
          text: "Add a company",
          to: `${paths.COMPANIES}?newCompany=true`,
          opensInNewTab: false,
          buttonName: "Add Company Card - Add Company",
        },
        secondaryCta: {
          text: "Core concepts",
          href: "https://docs.codat.io/core-concepts/companies",
          opensInNewTab: true,
          buttonName: "Add Company Card - Core Concepts",
        },
      };
    case "apiAccess":
      return {
        title: hasAPIKeyViewPermission
          ? "API access"
          : "Get to know the Portal",
        description: hasAPIKeyViewPermission
          ? "Admin and Developer users can view and regenerate the keys Codat uses control access to the API. "
          : "Learn how to add companies, view data, and setup your Codat solution through the Portal.",
        icon: hasAPIKeyViewPermission ? <ShareNetworkIcon /> : <VectorIcon />,
        primaryCta: {
          text: hasAPIKeyViewPermission ? "Get your API keys" : "Learn more",
          to: hasAPIKeyViewPermission ? paths.developers.API_KEYS : undefined,
          href: !hasAPIKeyViewPermission
            ? "https://docs.codat.io/other/portal/dashboard"
            : undefined,
          opensInNewTab: !hasAPIKeyViewPermission,
          buttonName: hasAPIKeyViewPermission
            ? "API Access Card - Get API Keys"
            : "Get To Know Portal Card - Learn More",
        },
      };
    default:
      return {
        title: "",
        description: "",
        icon: "",
        primaryCta: {
          text: "",
          href: "",
          opensInNewTab: false,
          buttonName: "",
        },
      };
  }
};
